import React from 'react';
import { Info } from 'lucide-react';

interface VatReturnUnusedBillInfoProps {
    count: number;
    onViewDocuments: () => void;
}

export default function VatReturnUnusedBillInfo({
    count,
    onViewDocuments
}: VatReturnUnusedBillInfoProps) {
    if (count === 0) {
        return null;
    }

    return (
        <div className="rounded-lg border border-gray-200 bg-white p-5">
            <div className="flex items-start gap-3">
                <Info className="mt-0.5 h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />
                <div>
                    <h3 className="mb-1 text-sm font-semibold text-gray-900">Niet meegenomen documenten</h3>
                    <p className="text-sm leading-relaxed text-gray-600">
                        {count} {count === 1 ? 'document was' : 'documenten waren'} niet meegenomen in de BTW-aangifte.{` `}
                        <button
                            type="button"
                            onClick={onViewDocuments}
                            className="font-semibold text-primary underline underline-offset-2 transition-opacity hover:opacity-80"
                        >
                            Bekijk
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
}
